export class PromoMechanic {
   constructor (promotion_id, type, quantity, product_type, product_id, product_name, line_id, line_name, presentation_id, presentation_name, products_str){
      this.promotion_id = promotion_id
      this.type = type
      this.quantity = quantity
      this.product_type = product_type
      this.product_id = product_id
      this.product_name = product_name
      this.line_id = line_id
      this.line_name = line_name
      this.presentation_id = presentation_id,
      this.presentation_name = presentation_name,
      this.products_str = products_str
   }

   static fromServiceMechanic(mec){
      return new PromoMechanic(
         mec.ID_Promocion,
         mec.Tipo_Mecanica,
         mec.Cantidad_Consumo,
         mec.Tipo_Producto,
         mec.ID_Producto,
         mec.Nm_Producto,
         mec.ID_Linea,
         mec.Nm_Linea,
         mec.ID_Presentacion,
         mec.Nm_Presentacion,
         mec.Productos_Participantes_String
      );
   }

   productos_Participantes(){
      return JSON.parse(this.products_str);
   }
   
}